/*
 * Cart Details Messages
 *
 * This contains all the text for the cart details component.
 */
import { defineMessages } from 'react-intl'

export default defineMessages({
  subtotal: {
    id: 'app.cartDetails.subtotal',
    description: 'Subtotal label',
  },
  legal: {
    id: 'app.cartDetails.legal',
    description: 'Taxes will be calculated during checkout',
  },
  cta: {
    id: 'app.cartDetails.cta',
    description: 'The call to action for moving to checkout view',
  },
  entitlementcta: {
    id: 'app.cartDetails.entitlementcta',
    description: 'The call to action for moving to checkout view when subtotal is 0',
  },
  entitlementDescription: {
    id: 'app.cartDetails.entitlement.description',
    description: "We've you covered.",
  },
})



// WEBPACK FOOTER //
// ./src/containers/Cart/CartDetails/messages.js